import React from 'react';
import styled from 'styled-components';
import plusIcon from '../../styles/images/icon-plus.png';
import FadeInUp from '../shared/Animation/FadeInUp';
import i18n from '../../config/i18n';

const Title = styled.div`
  font-size: 25px;
  font-weight: 700;
  text-align: center;
  color: #2C3E50;
  margin-bottom: 40px;
`;

const Paragraph = styled.div`
  font-size: 18px;
  font-weight: 700;
  line-height: 40px;
  text-align: center;
  color: #2C3E50;
  margin-bottom: 30px;
`;

const PlusIcon = styled.div`
  background-image: url(${plusIcon});
  background-size: 26px 26px;
  width: 26px;
  height: 26px;
  margin: 30px auto;
`;

const StyledSection = styled.section`
  background: white;

  @media screen and (max-width: 768px) {
    padding: 0 0 1em 0;
  }
`;

function InfoSection() {
  // Make "Sign up" string as an email link
  const introWithSignUp = i18n.t('intro_paragraph_lower_1', { iHealthCareCloudsTM: i18n.t('iHealthCareCloudsTM') })
    .split(/(Sign up)/i)
    .reduce((all, current) => (
      all.concat(current === 'Sign up'
        ? <a href="/subscription" key={current}>Sign up</a>
        : <span key={current}>{current}</span>)
    ), []);

  return (
    <StyledSection>
      <FadeInUp>
        <Title>
          {i18n.t('intro_title')}
        </Title>
        <Paragraph className="container">
          {i18n.t('intro_paragraph_upper_1')}
        </Paragraph>
        <PlusIcon />
        <Paragraph className="container">
          {introWithSignUp}
        </Paragraph>
        <Paragraph className="container">
          {i18n.t('iHealthCareCloudsTM')}
          {i18n.t('intro_paragraph_lower_2')}
        </Paragraph>
      </FadeInUp>
    </StyledSection>
  );
}

export default InfoSection;



// WEBPACK FOOTER //
// ./src/components/landing/InfoSection.js